import {
    observationFilter,
    observationSort,
    setObservationFilter,
    setObservationSort,
} from '@/types/observation'
const getDefaultState = () => {
    return {
        addedObservation: null,
        deletedObservation: null,
        updatedObservation: null,

        observationFilter: {
            ...observationFilter,
        },

        observationSort: {
            ...observationSort,
        },

        observationLayout: 'grid',

        aggregateFunction: ['count', 'avg', 'min', 'max', 'sum'],

        aggregatePeriod: ['day', 'week', 'month', 'quarter', 'year'],

        aggregatePeriodSource: ['happenedAt', 'publishedAt', 'updatedAt', 'closedAt'],

        observationColumns: {
            projectObservationId: {
                icon: 'fal fa-hashtag',
                permission: false,
            },
            numAttachments: {
                icon: 'fal fa-paperclip',
                permission: false,
            },
            numComments: {
                icon: 'fal fa-comment',
                permission: false,
            },
            numWatchers: {
                icon: 'fal fa-eye',
                permission: false,
            },
            severity: {
                icon: 'fal fa-dollar-sign',
                permission: false,
            },
            priority: {
                icon: 'fal fa-flag',
                check: 'edit_all_public_observations',
            },
            cost: {
                icon: 'fal fa-exclamation',
                permission: false,
            },
            reporter: {
                icon: 'fal fa-user',
                permission: false,
            },
            responsibleUser: {
                icon: 'fal fa-user',
                permission: false,
            },
            responsibleLeader: {
                icon: 'fal fa-user',
                permission: false,
            },
            contractors: {
                icon: 'fal fa-building',
                permission: false,
            },
            happenedAt: {
                icon: 'fal fa-calendar',
                check: false,
            },
            createdAt: {
                icon: 'fal fa-calendar',
                check: false,
            },
            updatedAt: {
                icon: 'fal fa-calendar',
                check: false,
            },
            publishedAt: {
                icon: 'fal fa-calendar',
                check: false,
            },
            dueWarning: {
                icon: 'fal fa-calendar',
                check: false,
            },
            due: {
                icon: 'fal fa-calendar',
                check: false,
            },
            dueStatus: {
                icon: 'fas fa-circle',
                check: false,
            },
            locationDrawing: {
                icon: 'fal fa-location',
                check: false,
            },
            location: {
                icon: 'fal fa-location',
                check: false,
            },
            category: {
                icon: 'fal fa-tag',
                check: false,
            },
            cause: {
                icon: 'fal fa-clipboard',
                check: false,
            },
        },

        observationColumnsArray: ['status', 'description', 'id'],
    }
}

const state = getDefaultState()

const getters = {
    addedObservation(state: any) {
        return state.addedObservation
    },

    deletedObservation(state: any) {
        return state.deletedObservation
    },

    updatedObservation(state: any) {
        return state.updatedObservation
    },

    observationFilter(state: any) {
        return state.observationFilter
    },

    observationSort(state: any) {
        return state.observationSort
    },

    observationLayout(state: any) {
        return state.observationLayout
    },

    observationColumns(state: any) {
        return state.observationColumns
    },

    observationColumnsArray(state: any) {
        return state.observationColumnsArray
    },

    ObservationStatChart(state: any) {
        return state.chart
    },

    ObservationStatFilterBy(state: any) {
        return state.ObservationStatFilterBy
    },

    observationAggregateFunction(state: any) {
        return state.aggregateFunction
    },

    observationAggregatePeriod(state: any) {
        return state.aggregatePeriod
    },

    observationAggregatePeriodSource(state: any) {
        return state.aggregatePeriodSource
    },
}

const mutations = {
    // MANAGE OBSERVATION
    addedObservation(state: any, payload: any) {
        state.addedObservation = payload
    },

    deletedObservation(state: any, payload: any) {
        state.deletedObservation = payload
    },

    updatedObservation(state: any, payload: any) {
        state.updatedObservation = payload
    },

    observationFilter(state: any, payload: any) {
        state.observationFilter = setObservationFilter(payload)
    },

    observationSort(state: any, payload: any) {
        state.observationSort = setObservationSort(payload)
    },

    observationLayout(state: any, payload: any) {
        state.observationLayout = payload
    },

    observationColumnsArray(state: any, payload: any) {
        state.observationColumnsArray = payload
    },

    //RESET
    resetObservationHelpers(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
